import mapKeys from 'lodash/mapKeys';
import mapValues from 'lodash/mapValues';
import { RICH_INLINE_NODE } from '../constants';
export var createNodeSpec = function createNodeSpec(name, attrs) {
  return {
    group: RICH_INLINE_NODE,
    content: 'text*',
    inline: true,
    atom: true,
    // treat node as a leaf
    attrs: attrs,
    toDOM: function toDOM(node) {
      var domAttrs = mapKeys(node.attrs, function (_, attr) {
        return "data-".concat(attr);
      });
      return [name, domAttrs, 0];
    },
    parseDOM: [{
      tag: name,
      getAttrs: function getAttrs(node) {
        if (node instanceof Element) {
          return mapValues(attrs, function (_, attr) {
            return node.getAttribute("data-".concat(attr));
          });
        }

        return null; // should never™ happen
      }
    }]
  };
};